import { render } from "./insurance-money.vue?vue&type=template&id=92282d7e&scoped=true&ts=true"
import script from "./insurance-money.vue?vue&type=script&lang=ts"
export * from "./insurance-money.vue?vue&type=script&lang=ts"

import "./insurance-money.vue?vue&type=style&index=0&id=92282d7e&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92282d7e"]])

export default __exports__